import { render, staticRenderFns } from "./activeloans.vue?vue&type=template&id=3d37362f"
import script from "./activeloans.vue?vue&type=script&lang=js"
export * from "./activeloans.vue?vue&type=script&lang=js"
import style0 from "./activeloans.vue?vue&type=style&index=0&id=3d37362f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports